import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import style from './Amenity.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import AmenityData from '../../../../assets/json/amenity.json';


//tab
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { handlePhoneCall } from '../../../../constants/webViewBridge';



const Amenity = () => {

    
    const location = useLocation();
    const { hsptlCd } = location.state || {};

    const curHospitalCode = hsptlCd;

    
    // 필터링 함수 추가
    const getFilteredList = () => {
        switch (value) {
            case '1': // 전체
                return AmenityData.filter(item => item.hsptl_cd === curHospitalCode);
            case '2': // 음료/음식점
                return AmenityData.filter(item => item.hsptl_cd === curHospitalCode && item.amenity_type === "A");
            case '3': // 의료기기/건강식품
                return AmenityData.filter(item => item.hsptl_cd === curHospitalCode && item.amenity_type === "B");
            case '4': // 편의점
                return AmenityData.filter(item => item.hsptl_cd === curHospitalCode && item.amenity_type === "C");
            default:
                return [];
        }
    };

    const hospital = AmenityData.filter(item => item.hsptl_cd === curHospitalCode);
    const hospitalNm = hospital[0].hsptl_Nm;

    
    //Tab
    const [value, setValue] = React.useState('1');
        
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }; 

    return (
        <>
            <HeadSub title="편의시설 정보" hospitalName={hospitalNm} /> 

            <div id="sub-content" data-type="d">
                <div className='inner-wrap' data-pad="normal">

                    <div className={style['top-fix-bar']}>
                        
                        
                        {/* 서울성모병원  */}
                        <TabContext value={value}>
                                <div className="top-tab-head" data-type="b">
                                    <TabList
                                        onChange={handleChange}
                                        aria-label="lab API tabs example"
                                        variant="scrollable"
                                        scrollButtons={false}
                                        className={style['tab-lists']}
                                    >
                                        <Tab label="전체" value="1" disableRipple />
                                        <Tab label="음료/음식점" value="2" disableRipple />
                                        <Tab label="의료기기/건강식품" value="3" disableRipple />
                                        <Tab label="편의점/기타" value="4" disableRipple />
                                    </TabList>
                                </div>

                                <div className={style['Note-box']}>
                                    <ul>
                                        <li>
                                        상황에 따라 운영 시간의 변동이 있을 수 있습니다.
                                        </li>
                                        <li>
                                        정확한 운영 시간은 각 시설에 확인 바랍니다.
                                        </li>
                                    </ul>
                                </div>   
                                <TabPanel value={value}>
                                     <div className={style['tab-content']}>

                                        <div className={style['list-boxs']}>
                                            <ul>

                                                {getFilteredList().map((item, index) => (
                                                    <li key={index}>
                                                        <div className={style['inner-box']}>
                                                            <div className={style['img-box']}>
                                                                <img src={item.img_url} alt={item.title} />
                                                            </div>
                                                            <div className={style['txt-box']}>
                                                                <strong>{item.title}</strong>
                                                                <p>{item.tel}</p>
                                                                <div className={style['info-box']}>
                                                                    <ul>
                                                                        {item.business_hours.map((time, i) => (
                                                                            <li key={i}>{time}</li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                                {item.location !== "" && (
                                                                    <p className={style['location']}>{item.location}</p>
                                                                )}
                                                                
                                                            </div>

                                                            {item.tel !== "" && (
                                                                <button 
                                                                    onClick={() => handlePhoneCall(item.tel)} 
                                                                    className={style['call-btn']}
                                                                    type="button"
                                                                >
                                                                    <span className='blind'>전화하기</span>
                                                                </button>
                                                            )}
                                                            
                                                        </div>
                                                    </li>
                                                ))}
                                                
                                            </ul>
                                        </div>

                                    </div>   
                                </TabPanel>
                                
                                


                        
                        </TabContext>
                        
                    </div>

                </div>
            </div>
            
        </>
    );
};

export default Amenity;
